import React from 'react'
import { Col, Row } from 'react-bootstrap'

const PlaceofBirth = props => {
  // props for this file from another
  const { sendValuechangedBoolean, sendinputdata, inputData } = props

  // function for setting react state of place of birth
  // in english and sending Boolean value true if value changed
  const placeofBirthEnglishfunction = event => {
    // setplaceofBirthEnglish(event.target.value)
    const inputData1 = { ...inputData }
    inputData1.PlaceofBirthen = event.target.value
    sendinputdata(inputData1)
    sendValuechangedBoolean('PlaceofBirthEn', true)
  }

  // function for setting react state of place of birth
  // in Telugu  and sending Boolean value true if value changed
  const placeofbirthTelugu = event => {
    // setplaceofbirthTelugu(event.target.value)
    const inputData1 = { ...inputData }
    inputData1.PlaceofBirthte = event.target.value
    sendinputdata(inputData1)
    sendValuechangedBoolean('PlaceofBirthTe', true)
  }

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <div>
              <label>Place of Birth_En</label>
            </div>
            <div>
              {/* textarea / input for entering place of birth */}
              <textarea
                type='text'
                value={inputData.PlaceofBirthen}
                className='form-control'
                disabled={props.disableInput === true}
                // on change in input field placeofBirthEnglishfunction if trigred
                onChange={event => placeofBirthEnglishfunction(event)}
              />
            </div>
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div>
            <div>
              <label>Place of Birth_Te</label>
            </div>
            <div>
              {/* textarea / input for entering place of birth  Telugu */}
              <textarea
                type='text'
                value={inputData.PlaceofBirthte}
                className='form-control'
                disabled={props.disableInput === true}
                // on change in input field placeofBirthEnglishfunction if trigred
                onChange={event => placeofbirthTelugu(event)}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default PlaceofBirth
